module.exports = __webpack_public_path__ + "static/img/index.ee60179b.png";